import { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { GetSensitiveDataChangesService } from "../../services/SensitiveData/GetSensitiveDataChangesService";
import { getToken } from "../../utils/GetToken";
import SensitiveChangesColumns from "../../utils/TableHeaders/SensitiveChangesHeaders";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { useReviewSensitiveChange } from "../../context/ReviewSensiteChangeContext";

export default function SensitiveDataChangesList() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const { sensitiveChangeApproved, sensitiveChangeRejected, resetSensitiveChangeStates } = useReviewSensitiveChange();

  useEffect(() => {
    getSensitiveChangesList();
    resetSensitiveChangeStates();
  }, [sensitiveChangeApproved, sensitiveChangeRejected]);

  const getSensitiveChangesList = async () => {
    try {
      const token = await getToken();
      if (token) {
        const data = await GetSensitiveDataChangesService(token);
        const mappedData = mapData(data);
        setRows(mappedData);
        console.log(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const mapData = (data) =>
    data.map((item) => {
      const createdAt = dayjs(item.createdAt).format("DD/MM/YYYY H:m:s A");
      const approvedAt = item?.approvedAt !== null ? dayjs(item?.approvedAt).format("DD/MM/YYYY H:m:s A") : "";
      const rejectedAt = item?.rejectedAt !== null ? dayjs(item?.rejectedAt).format("DD/MM/YYYY H:m:s A") : "";
      const mappedItem = {
        id: item.id,
        state: item.state,
        approverName: item.approverName,
        approverComment: item.approverComment,
        approvedAt: approvedAt,
        rejectedAt: rejectedAt,
        comment: item.comment,
        createdAt: createdAt,
      };
      return mappedItem;
    });

  return (
    <>
      <DataGrid
        rows={rows}
        columns={SensitiveChangesColumns()}
        loading={loading}
        disableRowSelectionOnClick
        hideFooter
        sx={{
          boxShadow: "0 1px 12px rgba(149, 157, 165, 0.2)",
          borderRadius: "25px",
          borderColor: "transparent",
          backgroundColor: "white",
          paddingX: "1.5rem",
          "& .MuiDataGrid-cell": {
            borderColor: "gray.light",
          },
          "& .MuiDataGrid-cell:hover": {
            color: "secondary.main",
          },
          "& .super-app-theme--header": {
            backgroundColor: "white",
          },
        }}
      />
    </>
  );
}
